export default function getPercentageValue(speakingPercentage) {
  return [...speakingPercentage]
    .sort((a, b) => b.percentual_fala - a.percentual_fala)
    .map((person) => ({
      ...person,
      percentual_fala: `${person.percentual_fala}%`,
    }));
}
